import { render, staticRenderFns } from "./NovaSideSheet.vue?vue&type=template&id=071c89d6&lang=pug&"
import script from "./NovaSideSheet.vue?vue&type=script&lang=js&"
export * from "./NovaSideSheet.vue?vue&type=script&lang=js&"
import style0 from "./NovaSideSheet.vue?vue&type=style&index=0&id=071c89d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports